import { Component, Input, OnInit } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
})
export class InfoComponent implements OnInit {
  @Input() public imgSrc: string;
  @Input() public title: string;
  @Input() public subTitleAttention: string;
  @Input() public subTitle: string;
  @Input() public hint: string;
  @Input() public hideTitleOnMobile: boolean = false;
  constructor() {}

  public ngOnInit(): void {}
}
